<div class="completed-issue-item"
     data-testid="completed-issue-item"
     role="article">
  <div class="issue-content"
       data-testid="issue-content">
    <button class="issue-text-btn"
            (click)="toggleExpansion()"
            data-testid="issue-text-btn"
            [attr.aria-expanded]="issue.expansionState === 'fully-expanded' ? 'true' : 'false'"
            [attr.aria-controls]="'issue-details-' + issue.id"
            [attr.aria-label]="'Toggle completed issue' + (issue.areaName ? ': ' + issue.areaName : '') + ' - ' + issue.text">
      <label class="issue-text"
             [class.full-text]="issue.expansionState === 'fully-expanded'"
             data-testid="issue-text"
             [attr.id]="'issue-text-' + issue.id">
        @if (issue.areaName) {
          <span class="area-prefix"><span class="area-name" data-testid="area-name">{{ issue.areaName }}:</span>&nbsp;<span class="first-char">{{ (issue.text || '') | slice:0:1 }}</span></span><span class="rest-text">{{ (issue.text || '') | slice:1 }}</span>
        } @else {
          {{ issue.text }}
        }
      </label>
      <i [class]="issue.expansionState === 'fully-expanded' ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
         class="chevron-icon"
         data-testid="chevron-icon"
         aria-hidden="true"></i>
    </button>
  </div>

  @if (issue.expansionState !== 'collapsed') {
  <div class="issue-details"
       data-testid="issue-details"
       role="region"
       [attr.id]="'issue-details-' + issue.id"
       [attr.aria-label]="'Completed issue details for ' + (issue.areaName ? issue.areaName + ': ' : '') + issue.text">
    @if (issue.expansionState === 'expanded') {
      <ng-container [ngTemplateOutlet]="issueTags"></ng-container>
    }

    @if (issue.expansionState === 'fully-expanded') {
      @if (issue.media && issue.media.length > 0) {
      <div class="issue-media"
           data-testid="issue-media"
           role="region"
           aria-label="Attached images">
        <div class="media-grid"
             data-testid="media-grid"
             role="list"
             [attr.aria-label]="'Media attachments, ' + mediaUrls().length + ' items'">
          @for (mediaUrl of mediaUrls(); track $index; let mediaIndex = $index) {
          <div class="media-cell"
               data-testid="media-cell"
               role="listitem">
            <img [src]="mediaUrl"
                 [alt]="'Issue media attachment ' + (mediaIndex + 1) + ' of ' + mediaUrls().length"
                 role="img" />
          </div>
          }
        </div>
      </div>
      }

      <ng-container [ngTemplateOutlet]="issueTags"></ng-container>
      <div class="actions">
        <button class="reopen-btn"
                (click)="onReopen()"
                data-testid="reopen-btn"
                aria-label="Reopen this completed issue">Reopen Item</button>
      </div>
    }
  </div>
  }
</div>

<!-- Reusable template for issue tags -->
<ng-template #issueTags>
  <div class="issue-tags"
       data-testid="issue-tags"
       role="group"
       aria-label="Completed status">
    <span class="tag completed" data-testid="completed-tag" aria-label="Completed date">Completed: {{ issue.completedAt | date:'MM/dd/yyyy' }}</span>
    @if (isSelfAssigned()) {
      <span class="tag trade-partner" data-testid="trade-partner-tag" role="status" aria-label="Assigned to me">
        Assigned to Me
      </span>
    } @else if (issue.jobIssueVendors && issue.jobIssueVendors.length > 0) {
      @for (assignment of issue.jobIssueVendors; track assignment.externalVendorId) {
        @if (!assignment.deleted) {
          <span class="tag trade-partner" data-testid="trade-partner-tag" role="status" [attr.aria-label]="'Assigned to vendor: ' + (getVendorNameById(assignment.externalVendorId) | titlecase)">
            {{ getVendorNameById(assignment.externalVendorId) | titlecase }}
          </span>
        }
      }
    }
  </div>
</ng-template>


